import { useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/leuteliaApi";
import { AuthFrame } from "./Login";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Loader2, KeyRound, CheckCircle2 } from "lucide-react";

export default function ImpostaPassword({ token }) {
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const strong = pw.length >= 10 && /[A-Z]/.test(pw) && /\d/.test(pw);
  const submit = async (e) => {
    e.preventDefault();
    if (pw !== pw2) return toast.error("Le due password non coincidono");
    setBusy(true);
    try { await api.setPassword({ token, password: pw }); setDone(true); }
    catch (err) { toast.error(err.message); } finally { setBusy(false); }
  };
  if (done) return (
    <AuthFrame title="Password impostata" sub="Ora puoi accedere a LEUTELIA con la tua email aziendale." testid="set-password-done">
      <div className="flex items-center gap-3 text-emerald-700 text-[14px] font-semibold"><CheckCircle2 size={20} /> Tutto pronto.</div>
      <Button onClick={() => { window.location.href = "/"; }} data-testid="set-password-go-login" className="mt-5 w-full h-11 rounded-lg bg-brand-green hover:bg-brand-greenDark text-brand-cream text-[14px] font-semibold">Vai all'accesso</Button>
    </AuthFrame>
  );
  return (
    <AuthFrame title="Scegli la tua password" sub="Almeno 10 caratteri, una maiuscola e un numero." testid="set-password-page">
      <form onSubmit={submit} className="space-y-4">
        <label className="block text-[12.5px] font-semibold text-brand-ink">Nuova password
          <Input data-testid="set-password-pw" type="password" value={pw} onChange={(e) => setPw(e.target.value)} required autoFocus className="mt-1 h-11" />
        </label>
        <label className="block text-[12.5px] font-semibold text-brand-ink">Ripeti la password
          <Input data-testid="set-password-pw2" type="password" value={pw2} onChange={(e) => setPw2(e.target.value)} required className="mt-1 h-11" />
        </label>
        <div className="text-[12px] text-brand-muted">{strong ? "Password abbastanza forte." : "Serve: 10+ caratteri, una maiuscola, un numero."}</div>
        <Button type="submit" disabled={busy || !strong} data-testid="set-password-submit" className="w-full h-11 rounded-lg bg-brand-green hover:bg-brand-greenDark text-brand-cream text-[14px] font-semibold">
          {busy ? <Loader2 size={16} className="mr-2 animate-spin" /> : <KeyRound size={16} className="mr-2" />} Salva la password
        </Button>
      </form>
    </AuthFrame>
  );
}
